import React, { createContext, useCallback, useContext, useState } from 'react';

interface PendingLineItemDrawerContextValue {
  pendingLineItemId: string | null;
  setPendingLineItemId: (id: string | null) => void;
}

const PendingLineItemDrawerContext = createContext<PendingLineItemDrawerContextValue>({
  pendingLineItemId: null,
  setPendingLineItemId: () => {},
});

export const usePendingLineItemDrawer = (): PendingLineItemDrawerContextValue =>
  useContext(PendingLineItemDrawerContext);

export const PendingLineItemDrawerProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [pendingLineItemId, setPendingLineItemIdState] = useState<string | null>(null);

  const setPendingLineItemId = useCallback((id: string | null) => {
    setPendingLineItemIdState(id);
  }, []);

  return (
    <PendingLineItemDrawerContext.Provider value={{ pendingLineItemId, setPendingLineItemId }}>
      {children}
    </PendingLineItemDrawerContext.Provider>
  );
};
